module.exports = __webpack_public_path__ + "img/IMG_2418.a373a9ed.jpg";